import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_39: FaireProductEntity = {
  token: "catalog_prod_prod-39",
  type: "product",
  name: "Accent Piece - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop",
  priceDollars: 78.07,
  msrpDollars: 195.18,
  sku: "PA0039",
  caseSize: 4,
  material: "Glass",
  collectionToken: "col_pattern-play",
  categoryTokens: ["catalog_cat_dogs"],
  isNew: true,
  isBestseller: true,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 19,
  description: "Beautiful Pattern Play piece perfect for any home.",
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
